import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { injectable } from "@launchtray/tsyringe-async";
import { IRenterPolicyModel } from "./IRenterPolicyModel";
import { RenterPolicyConfiguration } from "./RenterPolicyConfiguration";
import { RenterPolicyCycle } from "./RenterPolicyCycle";
import { RenterPolicyPenalties } from "./RenterPolicyPenalties";
import { RenterPolicyPrviousCycle } from "./RenterPolicyPrviousCycle";
import { RenterPolicyType } from "../../../popups/renterpolicy/components/RenterPolicyType";
import { ILatestNewsModel } from "../latestnews/ILatestNewsModel";
import { RenterPolicyCycleResult } from "../../../../networking/data/responses/renterPolicy/RenterPolicyCycleResult";

@injectable()
export class RenterPolicyFromNewsModel extends Bindable implements IRenterPolicyModel {
    public readonly configuration: NotifyProperty<RenterPolicyConfiguration>;
    public readonly cycle: NotifyProperty<RenterPolicyCycle>;
    public readonly penalties: NotifyProperty<RenterPolicyPenalties>;
    public readonly previousCycle: NotifyProperty<RenterPolicyPrviousCycle>;
    public readonly endsInTime: NotifyProperty<number>;
    public readonly isLowTime: NotifyProperty<boolean>;

    private readonly latestNewsModel: ILatestNewsModel;

    public get currentRenterPolicyType(): RenterPolicyType {
        return RenterPolicyType.NOTIFICATION_DEFAULT;
    }

    public constructor(latestNewsModel: ILatestNewsModel) {
        super();
        this.latestNewsModel = latestNewsModel;
        this.configuration = new NotifyProperty<RenterPolicyConfiguration>(this, nameof(this, "configuration"), undefined);
        this.cycle = new NotifyProperty<RenterPolicyCycle>(this, nameof(this, "cycle"), undefined);
        this.penalties = new NotifyProperty<RenterPolicyPenalties>(this, nameof(this, "penalties"), new RenterPolicyPenalties(this.latestNewsModel.latestNewsInfo.value.penalties));
        this.previousCycle = new NotifyProperty<RenterPolicyPrviousCycle>(this, nameof(this, "previousCycle"), new RenterPolicyPrviousCycle({ result: RenterPolicyCycleResult.INACTIVE_PERIOD, penaltiesCount: this.latestNewsModel.latestNewsInfo.value.penaltiesCount }));
        this.endsInTime = new NotifyProperty<number>(this, nameof(this, "endsInTime"), 0);
        this.isLowTime = new NotifyProperty<boolean>(this, nameof(this, "isLowTime"), false);
    }

    public async updateRenterPolicyStatus(): Promise<void> {
        throw new Error("Mot implemented.");
    }
}
